// src/context/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { translationFiles } from "../data/translationsFiles"

const LanguageContext = createContext();

export const LanguageProvider = ({ children, namespace = "spg" }) => {
  const [language, setLanguage] = useState("pt");

  useEffect(() => {
    const storedLang = localStorage.getItem("lang");
    if (storedLang) setLanguage(storedLang);
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("lang", lang);
  };

  const t = (key) => {
    const langData = translationFiles[namespace]?.[language];
    return langData?.[key] || key;
  };

  {/*const t = (key) => {
    const langData = translations[language] || translations["pt"];
    return langData[key] || key;
  };*/}

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
